import { render } from "./test.vue?vue&type=template&id=268cd73e&scoped=true"
import script from "./test.vue?vue&type=script&lang=js"
export * from "./test.vue?vue&type=script&lang=js"

import "./test.vue?vue&type=style&index=0&id=268cd73e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-268cd73e"

export default script